import { render, staticRenderFns } from "./EmailAwardsModal.vue?vue&type=template&id=3cdbe34c&scoped=true"
import script from "./EmailAwardsModal.vue?vue&type=script&lang=ts"
export * from "./EmailAwardsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbe34c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIInput: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/ui/UIInput.vue').default,UIButton: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/ui/UIButton.vue').default,UIModalContent: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/ui/UIModalContent.vue').default,UIModal: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/ui/UIModal.vue').default})
